import React from "react";
import { useHistory } from "react-router-dom";
import styles from "./pageNotFound.module.css";

interface NotFoundProps {
  message?: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

const NotFound: React.FC<NotFoundProps> = ({
  message = "Sorry, you don’t have permission to access this page.",
  buttonText = "Go to Home",
  onButtonClick,
}) => {
  const history = useHistory();

  const handleClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else {
      history.push("/");
    }
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Information!</h1>
      <p className={styles.message}>{message}</p>
      <button className={styles.button} onClick={handleClick}>
        {buttonText}
      </button>
    </div>
  );
};

export default NotFound;
